export const TEMPLATES = [
  /* ───────────────── TECH / DEV ───────────────── */
  {
    id: "dev_neon_dark",
    cat: "Tech / Dev",
    name: "Neon Dark",
    sub: "Coding vibe, moderno",
    color: "#00FF9C",
    icon: ">_",
    layout: "default",
    style: "dark_neon",
  },
  {
    id: "dev_minimal_mono",
    cat: "Tech / Dev",
    name: "Mono Minimal",
    sub: "Pulito, recruiter-friendly",
    color: "#9CA3AF",
    icon: "{}",
    layout: "default",
    style: "mono_clean",
  },
  {
    id: "dev_split_engineer",
    cat: "Tech / Dev",
    name: "Engineer Split",
    sub: "Strutturato, tecnico",
    color: "#3B82F6",
    icon: "01",
    layout: "split_left",
    style: "tech_split",
  },

  /* ───────────────── CREATIVO ───────────────── */
  {
    id: "creative_blocks",
    cat: "Creativo",
    name: "Color Blocks",
    sub: "Forte personalità",
    color: "#FF4D4D",
    icon: "◈",
    layout: "grid",
    style: "color_blocks",
  },
  {
    id: "creative_illustrated",
    cat: "Creativo",
    name: "Illustrato",
    sub: "Storytelling visivo",
    color: "#F59E0B",
    icon: "✦",
    layout: "cards",
    style: "illustration",
  },
  {
    id: "creative_poster",
    cat: "Creativo",
    name: "Poster",
    sub: "Tipografia forte",
    color: "#7C3AED",
    icon: "★",
    layout: "full_bleed",
    style: "poster",
  },

  /* ───────────────── MARKETING ───────────────── */
  {
    id: "marketing_infographic",
    cat: "Marketing",
    name: "Infografico",
    sub: "KPI e numeri",
    color: "#10B981",
    icon: "◉",
    layout: "grid",
    style: "kpi_dashboard",
  },
  {
    id: "marketing_gradient",
    cat: "Marketing",
    name: "Gradiente",
    sub: "Trend moderno",
    color: "#EC4899",
    icon: "✦",
    layout: "default",
    style: "gradient_modern",
  },
  {
    id: "marketing_split",
    cat: "Marketing",
    name: "Strategy Split",
    sub: "Chiaro e strutturato",
    color: "#8B5CF6",
    icon: "▲",
    layout: "split_left",
    style: "marketing_split",
  },

  /* ───────────────── STARTUP / PM ───────────────── */
  {
    id: "startup_cards",
    cat: "Startup / PM",
    name: "Product Cards",
    sub: "Mentalità prodotto",
    color: "#F97316",
    icon: "⬚",
    layout: "cards",
    style: "app_ui",
  },
  {
    id: "startup_timeline",
    cat: "Startup / PM",
    name: "Roadmap",
    sub: "Visione prodotto",
    color: "#F59E0B",
    icon: "▲",
    layout: "timeline",
    style: "roadmap",
  },
  {
    id: "startup_bold",
    cat: "Startup / PM",
    name: "Bold Minimal",
    sub: "Decisionale",
    color: "#2563EB",
    icon: "■",
    layout: "default",
    style: "bold_minimal",
  },

  /* ───────────────── FINANCE / LAW ───────────────── */
  {
    id: "finance_corporate",
    cat: "Finance / Law",
    name: "Corporate Blue",
    sub: "Affidabilità",
    color: "#1E3A8A",
    icon: "▣",
    layout: "default",
    style: "corporate",
  },
  {
    id: "finance_serif",
    cat: "Finance / Law",
    name: "Serif Elegante",
    sub: "Autorevolezza",
    color: "#111827",
    icon: "◆",
    layout: "default",
    style: "serif",
  },
  {
    id: "finance_split",
    cat: "Finance / Law",
    name: "Executive Split",
    sub: "Dirigenziale",
    color: "#374151",
    icon: "✦",
    layout: "split_left",
    style: "executive",
  },

  /* ───────────────── ACCADEMIA ───────────────── */
  {
    id: "academic_classic",
    cat: "Accademia",
    name: "Classico",
    sub: "Struttura rigorosa",
    color: "#6D28D9",
    icon: "◇",
    layout: "default",
    style: "latex",
  },
  {
    id: "academic_timeline",
    cat: "Accademia",
    name: "Ricerca Timeline",
    sub: "Carriera accademica",
    color: "#7C3AED",
    icon: "⌘",
    layout: "timeline",
    style: "academic_timeline",
  },
  {
    id: "academic_columns",
    cat: "Accademia",
    name: "Colonne",
    sub: "Pubblicazioni e studi",
    color: "#5B21B6",
    icon: "▤",
    layout: "grid",
    style: "academic_columns",
  },

  /* ───────────────── PA / NON PROFIT ───────────────── */
  {
    id: "civic_neutral",
    cat: "PA / Non-profit",
    name: "Istituzionale",
    sub: "Serio e chiaro",
    color: "#6B7280",
    icon: "⬤",
    layout: "default",
    style: "neutral",
  },
  {
    id: "civic_split",
    cat: "PA / Non-profit",
    name: "Amministrativo",
    sub: "Strutturato",
    color: "#9CA3AF",
    icon: "▥",
    layout: "split_left",
    style: "civic_split",
  },
  {
    id: "civic_formal",
    cat: "PA / Non-profit",
    name: "Formale",
    sub: "Documentale",
    color: "#4B5563",
    icon: "▦",
    layout: "default",
    style: "formal_doc",
  },

  /* ───────────────── SANITÀ ───────────────── */
  {
    id: "health_clean",
    cat: "Sanità",
    name: "Clinico",
    sub: "Pulito e rassicurante",
    color: "#10B981",
    icon: "✚",
    layout: "default",
    style: "medical_clean",
  },
  {
    id: "health_split",
    cat: "Sanità",
    name: "Medico Split",
    sub: "Organizzato",
    color: "#059669",
    icon: "✚",
    layout: "split_left",
    style: "medical_split",
  },
  {
    id: "health_cards",
    cat: "Sanità",
    name: "Wellness",
    sub: "Energia e coaching",
    color: "#84CC16",
    icon: "◑",
    layout: "cards",
    style: "wellness",
  },

  /* ───────────────── INGEGNERIA ───────────────── */
  {
    id: "eng_grid",
    cat: "Ingegneria",
    name: "Geometrico",
    sub: "Precisione tecnica",
    color: "#0284C7",
    icon: "⌖",
    layout: "grid",
    style: "engineering_grid",
  },
  {
    id: "eng_blueprint",
    cat: "Ingegneria",
    name: "Blueprint",
    sub: "Disegno tecnico",
    color: "#0369A1",
    icon: "⚙",
    layout: "default",
    style: "blueprint",
  },
  {
    id: "eng_process",
    cat: "Ingegneria",
    name: "Processo",
    sub: "Flow e logica",
    color: "#0EA5E9",
    icon: "⚙",
    layout: "timeline",
    style: "process_flow",
  },

  /* ───────────────── ARCHITETTURA ───────────────── */
  {
    id: "arch_portfolio",
    cat: "Architettura",
    name: "Portfolio",
    sub: "Focus progetti",
    color: "#E5E7EB",
    icon: "⌗",
    layout: "grid",
    style: "portfolio",
  },
  {
    id: "arch_mono",
    cat: "Architettura",
    name: "Mono Elegante",
    sub: "Estetica sofisticata",
    color: "#111827",
    icon: "▧",
    layout: "default",
    style: "monochrome",
  },
  {
    id: "arch_split",
    cat: "Architettura",
    name: "Studio",
    sub: "Layout professionale",
    color: "#9CA3AF",
    icon: "▨",
    layout: "split_left",
    style: "studio",
  },

  /* ───────────────── LUXURY / FASHION ───────────────── */
  {
    id: "luxury_gold",
    cat: "Luxury / Fashion",
    name: "Black Gold",
    sub: "Lusso minimale",
    color: "#D4AF37",
    icon: "◈",
    layout: "default",
    style: "luxury",
  },
  {
    id: "luxury_editorial",
    cat: "Luxury / Fashion",
    name: "Magazine",
    sub: "Fashion storytelling",
    color: "#000000",
    icon: "✦",
    layout: "full_bleed",
    style: "editorial",
  },
  {
    id: "luxury_split",
    cat: "Luxury / Fashion",
    name: "Atelier",
    sub: "Eleganza strutturata",
    color: "#C0A060",
    icon: "◉",
    layout: "split_left",
    style: "atelier",
  },

  /* ───────────────── MEDIA / CULTURA ───────────────── */
  {
    id: "media_editorial",
    cat: "Media / Cultura",
    name: "Editoriale",
    sub: "Tipografia forte",
    color: "#EF4444",
    icon: "✎",
    layout: "full_bleed",
    style: "editorial_media",
  },
  {
    id: "media_columns",
    cat: "Media / Cultura",
    name: "Giornale",
    sub: "Stile newspaper",
    color: "#1F2937",
    icon: "▤",
    layout: "grid",
    style: "newspaper",
  },
  {
    id: "media_creative",
    cat: "Media / Cultura",
    name: "Creative Mix",
    sub: "Espressivo",
    color: "#F43F5E",
    icon: "✦",
    layout: "cards",
    style: "creative_mix",
  },

  /* ───────────────── NON LAUREATI ───────────────── */
  {
    id: "simple_clean",
    cat: "Pratico",
    name: "Chiaro",
    sub: "Diretto e leggibile",
    color: "#374151",
    icon: "◌",
    layout: "default",
    style: "simple",
  },
  {
    id: "simple_split",
    cat: "Pratico",
    name: "Esperienza",
    sub: "Focus lavoro",
    color: "#6B7280",
    icon: "▤",
    layout: "split_left",
    style: "experience",
  },
  {
    id: "simple_timeline",
    cat: "Pratico",
    name: "Timeline",
    sub: "Percorso chiaro",
    color: "#9CA3AF",
    icon: "▥",
    layout: "timeline",
    style: "simple_timeline",
  },
];
